import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import NewsGrid from './components/NewsGrid';
import TrendingSidebar from './components/TrendingSidebar';

export default function Home() {
  const location = useLocation();

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51黑料 - 51黑料网首页 | 娱乐八卦明星爆料平台',
    description: '51黑料网官网首页，提供最新娱乐八卦、明星爆料、网红热点、社会事件深度揭秘等资讯内容。51黑料网站首页汇集全网最热爆料信息。',
    url: 'https://www.51heilia.com',
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(webPageSchema)}
      </script>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <HeroSection />

        <main className="w-full">
          <div className="py-6">
            <CategoryTabs />
          </div>

          <div className="w-full px-4 md:px-6 pb-14">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-flashlight-line text-primary-500 text-lg"></i>
                  </div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950">
                    最新爆料
                  </h2>
                </div>
                <NewsGrid />
              </div>
              <TrendingSidebar />
            </div>
          </div>

          <section className="w-full px-4 md:px-6 py-14 bg-background-100">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                关于51黑料
              </h2>
              <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
                51黑料网是专业的娱乐资讯平台，致力于为用户提供最新、最全、最真实的娱乐八卦与明星爆料内容。我们坚持独立、客观的报道立场，深度挖掘娱乐圈背后的故事。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
              {[
                { icon: 'ri-shield-check-line', title: '真实可靠', desc: '多方核实信息来源，确保内容真实可信' },
                { icon: 'ri-flashlight-line', title: '快速及时', desc: '第一时间报道热点事件，不让您错过任何瓜' },
                { icon: 'ri-search-eye-line', title: '深度挖掘', desc: '不止于表面，深度调查揭示事件背后的真相' },
                { icon: 'ri-user-heart-line', title: '用户至上', desc: '以用户需求为导向，持续优化内容与服务' },
              ].map((item, index) => (
                <div key={index} className="text-center p-5">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                    <i className={`${item.icon} text-primary-500 text-2xl`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-14">
            <div className="text-center mb-8">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mb-2">
                常见问题
              </h2>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: '51黑料网是什么平台？', a: '51黑料网是一个专业的娱乐资讯平台，为用户提供最新的娱乐八卦、明星爆料、网红热点以及社会事件深度揭秘等内容。我们致力于做最真实、最及时的娱乐资讯门户。' },
                { q: '如何访问51黑料官网？', a: '您可以通过51黑料官网入口地址直接访问本网站。51黑料网站首页汇集了最新最热的爆料内容，支持网页版和移动端浏览，无需下载即可畅享全部内容。' },
                { q: '51黑料网的内容可靠吗？', a: '51黑料网坚持多方核实信息来源，确保每一条发布的内容都经过严格的审核流程。我们拥有专业的编辑团队和调查记者，致力于为用户提供真实可信的资讯服务。' },
                { q: '如何在51黑料网投稿或爆料？', a: '您可以通过"关于我们"页面的联系方式与我们取得联系。我们欢迎用户提供有价值的爆料线索，所有投稿均会经过编辑团队的审核评估。' },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                    <span className="font-medium text-foreground-800 text-sm">
                      {faq.q}
                    </span>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-s-line text-secondary-500 group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>

            <script type="application/ld+json">
              {JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [
                  { '@type': 'Question', name: '51黑料网是什么平台？', acceptedAnswer: { '@type': 'Answer', text: '51黑料网是一个专业的娱乐资讯平台，为用户提供最新的娱乐八卦、明星爆料、网红热点以及社会事件深度揭秘等内容。' } },
                  { '@type': 'Question', name: '如何访问51黑料官网？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过51黑料官网入口地址直接访问本网站。51黑料网站首页汇集了最新最热的爆料内容，支持网页版和移动端浏览。' } },
                  { '@type': 'Question', name: '51黑料网的内容可靠吗？', acceptedAnswer: { '@type': 'Answer', text: '51黑料网坚持多方核实信息来源，确保每一条发布的内容都经过严格的审核流程，致力于为用户提供真实可信的资讯服务。' } },
                  { '@type': 'Question', name: '如何在51黑料网投稿或爆料？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过关于我们页面的联系方式与我们取得联系，欢迎提供有价值的爆料线索。' } },
                ],
              })}
            </script>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}